import axios from "axios";
import axiosInstance from "../login/AxiosServiseFactory";
import { baseUrl, cloudinaryBaseUrl } from "../login/baseUrl";

export const login = (data) => {
  // /user/loginAdmin
  return axios.post(`${baseUrl}/adminuser/loginOtp`, data, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const addUser = (data) => {
  return axios.post(`${baseUrl}/adminuser/register`, data, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};


export const updateUser = (id, data) => {
  return axios.put(`${baseUrl}/adminuser/edit/${id}`, data, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const getAllUser = (val) => {
  return axios.get(`${baseUrl}/adminuser/all?count=${val?.count}&page=${val?.page}&search=${val?.search}`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};
export const deleteUser = (id) => {
  return axios.delete(`${baseUrl}/adminuser/delete/${id}`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const geteditUser = (id) => {
  return axios.get(`${baseUrl}/adminuser/get/${id}`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};


export const getSkill = () => {
  return axios.get(`${baseUrl}/job-skills`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const getSkillall = () => {
  return axios.get(`${baseUrl}/job-skills/public`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};


export const addJob = (data) => {
  return axios.post(`${baseUrl}/jobs/add`, data, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};



export const getJobsList = (count, page) => {
  return axios.get(`${baseUrl}/jobs/all?page=${page}&count=10`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};
export const deleteJobsList = (id) => {
  return axios.delete(`${baseUrl}/jobs/delete/${id}`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const geteditjob = (id) => {
  return axios.get(`${baseUrl}/jobs/getId/${id}`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const updateJob = (id, data) => {
  return axios.put(`${baseUrl}/jobs/updateJob/${id}`, data, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};


export const getCateg = (id) => {
  // category / jobCategory
  return axios.get(`${baseUrl}/job-category/all-category`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const getLocations = (id) => {
  // category / jobCategory
  return axios.get(`${baseUrl}/location/all-location`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};


export const getLocation = (id) => {
  return axios.get(`${baseUrl}/cities/all`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};
export const getAllCity = (id) => {
  return axios.get(`${baseUrl}/cities/public`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const getJobSkills = (id) => {
  return axios.get(`${baseUrl}/job-skills`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};
export const getCompany = (id) => {
  return axios.get(`${baseUrl}/company`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};
export const getIndustry = (id) => {
  return axios.get(`${baseUrl}/industry`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};
export const getIndustryAll = (id) => {
  return axios.get(`${baseUrl}/industry/public`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};
export const getGender = (id) => {
  return axios.get(`${baseUrl}/gender`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const getUserByid = (id) => {
  return axios.get(`${baseUrl}/candidate/get/${id}`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const addCandidate = (data) => {
  return axios.post(`${baseUrl}/candidate/add`, data, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const uploadFile = (data) => {
  return axios.post(`${baseUrl}/import/file`, data, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const getCandidate = (page) => {
  return axios.get(`${baseUrl}/candidate/all?page=${page}&count=10`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};


export const getCandidateByid = (id) => {
  return axios.get(`${baseUrl}/candidate/get/${id}`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};



export const updateCandid = (id, data) => {
  return axios.put(`${baseUrl}/candidate/update/${id}`, data, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};


export const getHistoryLogin = (value) => {
  return axios.get(`${baseUrl}/loginlogs?page=${value?.page}&count=${value?.count}`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};
export const getProfileApi = (page) => {
  return axios.get(`${baseUrl}/adminuser/profile`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const getCountryApi = (page) => {
  return axios.get(`${baseUrl}/countries/public`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};
export const getStateApi = (page) => {
  return axios.get(`${baseUrl}/states/public`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};
export const getCityApi = (page) => {
  return axios.get(`${baseUrl}/cities/public`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const getImagePost = (value) => {
  return axios.post(`${cloudinaryBaseUrl}addImage`, value, {
    headers: {
      // "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const getLanguage = (value) => {
  return axios.get(`${baseUrl}/language`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};
export const getCreateCompany = (value) => {
  return axios.post(`${baseUrl}/getCreateCompany`, value, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const getLoginPageDynemic = (value) => {
  return axios.get(`${baseUrl}/company-master/public`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const LoginOtp = (value) => {
  return axios.post(`${baseUrl}/adminuser/verifyOtp`, value, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};
export const LogoutApi = (value) => {
  return axios.delete(`${baseUrl}/loginlogs/logout`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};
export const allUsertApi = (value) => {
  return axios.get(`${baseUrl}/adminuser/publicUser`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};
export const getDashboardApi = (value) => {
  return axios.get(`${baseUrl}/dashboard`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};
export const getPasswordChange = (value) => {
  return axios.put(`${baseUrl}/adminuser/changePasswordByAdmin`, value, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const deleteApiCandidate = (id) => {
  return axios.delete(`${baseUrl}/candidate/delete/${id}`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const deleteApiCity = (id) => {
  return axios.delete(`${baseUrl}/cities/delete/${id}`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
}
export const deleteApigender = (id) => {
  return axios.delete(`${baseUrl}/gender/delete/${id}`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
}
export const deleteApiIndustry = (id) => {
  return axios.delete(`${baseUrl}/industry/delete/${id}`, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
}
export const sendBulkMailApi = (value) => {
  return axios.post(`${baseUrl}/sendBulkMail`, value, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
}


export const profileUpdate = (value) => {
  return axios.put(`${baseUrl}/adminuser/update-profile`, value, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
};

export const resetPasswod = (value) => {
  return axios.post(`${baseUrl}/adminuser/password-reset-link`, value, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
}
export const resetPasswodLink = (value) => {
  return axios.post(`${baseUrl}/adminuser/password-reset`, value, {
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${window.localStorage.getItem('token')}`,
    },
  });
}



